import { render, staticRenderFns } from "./WebLinkLuxuryGold.vue?vue&type=template&id=1ac32e5c&scoped=true&"
import script from "./WebLinkLuxuryGold.vue?vue&type=script&lang=js&"
export * from "./WebLinkLuxuryGold.vue?vue&type=script&lang=js&"
import style0 from "./WebLinkLuxuryGold.vue?vue&type=style&index=0&id=1ac32e5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac32e5c",
  null
  
)

export default component.exports